import { useTranslation } from 'react-i18next'

import { Trans } from '@/components'
import { Dropdown } from '@/components/base/Dropdown'
import { TeamRole } from '@/consts/team'

interface DataFiltersProps {
  // Role filter
  selectedRoles: number[]
  onRolesChange: (roles: number[]) => void
}

/**
 * Data management filters component
 * Provides Role filtering only (Region removed due to API limitations)
 */
export function DataFilters({ selectedRoles, onRolesChange }: DataFiltersProps) {
  const { t } = useTranslation()

  const roleOptions = [
    {
      label: t('team.role.owner', 'Owner'),
      value: TeamRole.Owner,
      className: 't-sm',
    },
    {
      label: t('team.role.admin', 'Admin'),
      value: TeamRole.Admin,
      className: 't-sm',
    },
    {
      label: t('team.role.member', 'Member'),
      value: TeamRole.Normal,
      className: 't-sm',
    },
  ]

  const handleRoleChange = (value: (string | number)[] | string | number) => {
    if (Array.isArray(value)) {
      // Filter out 'all' and convert to numbers
      const roles = value.filter((v) => v !== 'all') as number[]
      onRolesChange(roles)
    } else if (value === 'all') {
      onRolesChange([])
    } else {
      onRolesChange([value as number])
    }
  }

  return (
    <div className="flex items-end gap-3">
      {/* Role Filter */}
      <div className="flex flex-col gap-2">
        <label className="t-sb text-secondary">
          <Trans i18nKey="teamData.admin.roleFilter">Role</Trans>
        </label>
        <Dropdown
          rootClassName="w-[200px]"
          options={roleOptions}
          value={selectedRoles.length === 0 ? ['all'] : selectedRoles}
          onChange={handleRoleChange}
          multiple={true}
          showAllOption={true}
          placeholder={t('teamData.admin.selectRole', 'Select role')}
        />
      </div>
    </div>
  )
}
